const translations = {
    breadcrumbChemicals: 'Chemicals',
    breadcrumbMixApply: 'Mix & Apply',
    breadcrumbMixes: 'Mixes',
    completeApplication: 'Complete Application',
    mixDetailButton: '\u2190 Mix Detail',
    productCountPlural: '{{count}} products',
    productCountSingular: '{{count}} product',
    title: 'Mix & Apply'
};

export default translations;
